/* eslint-disable max-lines */ // @flow
/*
 * Always keep this file in sync with `api` repository.
 */
export const UTC_TIMEZONE_ID = 589;
// generated using:
// import moment from 'moment-timezone'
// console.log(JSON.stringify(moment.tz.names().map((value, index) => ({value: index + 1, label: value})), null, 2));
export default [
    {
        "value": 1,
        "label": "Africa/Abidjan",
    },
    {
        "value": 2,
        "label": "Africa/Accra",
    },
    {
        "value": 3,
        "label": "Africa/Addis_Ababa",
    },
    {
        "value": 4,
        "label": "Africa/Algiers",
    },
    {
        "value": 5,
        "label": "Africa/Asmara",
    },
    {
        "value": 6,
        "label": "Africa/Asmera",
    },
    {
        "value": 7,
        "label": "Africa/Bamako",
    },
    {
        "value": 8,
        "label": "Africa/Bangui",
    },
    {
        "value": 9,
        "label": "Africa/Banjul",
    },
    {
        "value": 10,
        "label": "Africa/Bissau",
    },
    {
        "value": 11,
        "label": "Africa/Blantyre",
    },
    {
        "value": 12,
        "label": "Africa/Brazzaville",
    },
    {
        "value": 13,
        "label": "Africa/Bujumbura",
    },
    {
        "value": 14,
        "label": "Africa/Cairo",
    },
    {
        "value": 15,
        "label": "Africa/Casablanca",
    },
    {
        "value": 16,
        "label": "Africa/Ceuta",
    },
    {
        "value": 17,
        "label": "Africa/Conakry",
    },
    {
        "value": 18,
        "label": "Africa/Dakar",
    },
    {
        "value": 19,
        "label": "Africa/Dar_es_Salaam",
    },
    {
        "value": 20,
        "label": "Africa/Djibouti",
    },
    {
        "value": 21,
        "label": "Africa/Douala",
    },
    {
        "value": 22,
        "label": "Africa/El_Aaiun",
    },
    {
        "value": 23,
        "label": "Africa/Freetown",
    },
    {
        "value": 24,
        "label": "Africa/Gaborone",
    },
    {
        "value": 25,
        "label": "Africa/Harare",
    },
    {
        "value": 26,
        "label": "Africa/Johannesburg",
    },
    {
        "value": 27,
        "label": "Africa/Juba",
    },
    {
        "value": 28,
        "label": "Africa/Kampala",
    },
    {
        "value": 29,
        "label": "Africa/Khartoum",
    },
    {
        "value": 30,
        "label": "Africa/Kigali",
    },
    {
        "value": 31,
        "label": "Africa/Kinshasa",
    },
    {
        "value": 32,
        "label": "Africa/Lagos",
    },
    {
        "value": 33,
        "label": "Africa/Libreville",
    },
    {
        "value": 34,
        "label": "Africa/Lome",
    },
    {
        "value": 35,
        "label": "Africa/Luanda",
    },
    {
        "value": 36,
        "label": "Africa/Lubumbashi",
    },
    {
        "value": 37,
        "label": "Africa/Lusaka",
    },
    {
        "value": 38,
        "label": "Africa/Malabo",
    },
    {
        "value": 39,
        "label": "Africa/Maputo",
    },
    {
        "value": 40,
        "label": "Africa/Maseru",
    },
    {
        "value": 41,
        "label": "Africa/Mbabane",
    },
    {
        "value": 42,
        "label": "Africa/Mogadishu",
    },
    {
        "value": 43,
        "label": "Africa/Monrovia",
    },
    {
        "value": 44,
        "label": "Africa/Nairobi",
    },
    {
        "value": 45,
        "label": "Africa/Ndjamena",
    },
    {
        "value": 46,
        "label": "Africa/Niamey",
    },
    {
        "value": 47,
        "label": "Africa/Nouakchott",
    },
    {
        "value": 48,
        "label": "Africa/Ouagadougou",
    },
    {
        "value": 49,
        "label": "Africa/Porto-Novo",
    },
    {
        "value": 50,
        "label": "Africa/Sao_Tome",
    },
    {
        "value": 51,
        "label": "Africa/Timbuktu",
    },
    {
        "value": 52,
        "label": "Africa/Tripoli",
    },
    {
        "value": 53,
        "label": "Africa/Tunis",
    },
    {
        "value": 54,
        "label": "Africa/Windhoek",
    },
    {
        "value": 55,
        "label": "America/Adak",
    },
    {
        "value": 56,
        "label": "America/Anchorage",
    },
    {
        "value": 57,
        "label": "America/Anguilla",
    },
    {
        "value": 58,
        "label": "America/Antigua",
    },
    {
        "value": 59,
        "label": "America/Araguaina",
    },
    {
        "value": 60,
        "label": "America/Argentina/Buenos_Aires",
    },
    {
        "value": 61,
        "label": "America/Argentina/Catamarca",
    },
    {
        "value": 62,
        "label": "America/Argentina/ComodRivadavia",
    },
    {
        "value": 63,
        "label": "America/Argentina/Cordoba",
    },
    {
        "value": 64,
        "label": "America/Argentina/Jujuy",
    },
    {
        "value": 65,
        "label": "America/Argentina/La_Rioja",
    },
    {
        "value": 66,
        "label": "America/Argentina/Mendoza",
    },
    {
        "value": 67,
        "label": "America/Argentina/Rio_Gallegos",
    },
    {
        "value": 68,
        "label": "America/Argentina/Salta",
    },
    {
        "value": 69,
        "label": "America/Argentina/San_Juan",
    },
    {
        "value": 70,
        "label": "America/Argentina/San_Luis",
    },
    {
        "value": 71,
        "label": "America/Argentina/Tucuman",
    },
    {
        "value": 72,
        "label": "America/Argentina/Ushuaia",
    },
    {
        "value": 73,
        "label": "America/Aruba",
    },
    {
        "value": 74,
        "label": "America/Asuncion",
    },
    {
        "value": 75,
        "label": "America/Atikokan",
    },
    {
        "value": 76,
        "label": "America/Atka",
    },
    {
        "value": 77,
        "label": "America/Bahia",
    },
    {
        "value": 78,
        "label": "America/Bahia_Banderas",
    },
    {
        "value": 79,
        "label": "America/Barbados",
    },
    {
        "value": 80,
        "label": "America/Belem",
    },
    {
        "value": 81,
        "label": "America/Belize",
    },
    {
        "value": 82,
        "label": "America/Blanc-Sablon",
    },
    {
        "value": 83,
        "label": "America/Boa_Vista",
    },
    {
        "value": 84,
        "label": "America/Bogota",
    },
    {
        "value": 85,
        "label": "America/Boise",
    },
    {
        "value": 86,
        "label": "America/Buenos_Aires",
    },
    {
        "value": 87,
        "label": "America/Cambridge_Bay",
    },
    {
        "value": 88,
        "label": "America/Campo_Grande",
    },
    {
        "value": 89,
        "label": "America/Cancun",
    },
    {
        "value": 90,
        "label": "America/Caracas",
    },
    {
        "value": 91,
        "label": "America/Catamarca",
    },
    {
        "value": 92,
        "label": "America/Cayenne",
    },
    {
        "value": 93,
        "label": "America/Cayman",
    },
    {
        "value": 94,
        "label": "America/Chicago",
    },
    {
        "value": 95,
        "label": "America/Chihuahua",
    },
    {
        "value": 96,
        "label": "America/Coral_Harbour",
    },
    {
        "value": 97,
        "label": "America/Cordoba",
    },
    {
        "value": 98,
        "label": "America/Costa_Rica",
    },
    {
        "value": 99,
        "label": "America/Creston",
    },
    {
        "value": 100,
        "label": "America/Cuiaba",
    },
    {
        "value": 101,
        "label": "America/Curacao",
    },
    {
        "value": 102,
        "label": "America/Danmarkshavn",
    },
    {
        "value": 103,
        "label": "America/Dawson",
    },
    {
        "value": 104,
        "label": "America/Dawson_Creek",
    },
    {
        "value": 105,
        "label": "America/Denver",
    },
    {
        "value": 106,
        "label": "America/Detroit",
    },
    {
        "value": 107,
        "label": "America/Dominica",
    },
    {
        "value": 108,
        "label": "America/Edmonton",
    },
    {
        "value": 109,
        "label": "America/Eirunepe",
    },
    {
        "value": 110,
        "label": "America/El_Salvador",
    },
    {
        "value": 111,
        "label": "America/Ensenada",
    },
    {
        "value": 112,
        "label": "America/Fort_Nelson",
    },
    {
        "value": 113,
        "label": "America/Fort_Wayne",
    },
    {
        "value": 114,
        "label": "America/Fortaleza",
    },
    {
        "value": 115,
        "label": "America/Glace_Bay",
    },
    {
        "value": 116,
        "label": "America/Godthab",
    },
    {
        "value": 117,
        "label": "America/Goose_Bay",
    },
    {
        "value": 118,
        "label": "America/Grand_Turk",
    },
    {
        "value": 119,
        "label": "America/Grenada",
    },
    {
        "value": 120,
        "label": "America/Guadeloupe",
    },
    {
        "value": 121,
        "label": "America/Guatemala",
    },
    {
        "value": 122,
        "label": "America/Guayaquil",
    },
    {
        "value": 123,
        "label": "America/Guyana",
    },
    {
        "value": 124,
        "label": "America/Halifax",
    },
    {
        "value": 125,
        "label": "America/Havana",
    },
    {
        "value": 126,
        "label": "America/Hermosillo",
    },
    {
        "value": 127,
        "label": "America/Indiana/Indianapolis",
    },
    {
        "value": 128,
        "label": "America/Indiana/Knox",
    },
    {
        "value": 129,
        "label": "America/Indiana/Marengo",
    },
    {
        "value": 130,
        "label": "America/Indiana/Petersburg",
    },
    {
        "value": 131,
        "label": "America/Indiana/Tell_City",
    },
    {
        "value": 132,
        "label": "America/Indiana/Vevay",
    },
    {
        "value": 133,
        "label": "America/Indiana/Vincennes",
    },
    {
        "value": 134,
        "label": "America/Indiana/Winamac",
    },
    {
        "value": 135,
        "label": "America/Indianapolis",
    },
    {
        "value": 136,
        "label": "America/Inuvik",
    },
    {
        "value": 137,
        "label": "America/Iqaluit",
    },
    {
        "value": 138,
        "label": "America/Jamaica",
    },
    {
        "value": 139,
        "label": "America/Jujuy",
    },
    {
        "value": 140,
        "label": "America/Juneau",
    },
    {
        "value": 141,
        "label": "America/Kentucky/Louisville",
    },
    {
        "value": 142,
        "label": "America/Kentucky/Monticello",
    },
    {
        "value": 143,
        "label": "America/Knox_IN",
    },
    {
        "value": 144,
        "label": "America/Kralendijk",
    },
    {
        "value": 145,
        "label": "America/La_Paz",
    },
    {
        "value": 146,
        "label": "America/Lima",
    },
    {
        "value": 147,
        "label": "America/Los_Angeles",
    },
    {
        "value": 148,
        "label": "America/Louisville",
    },
    {
        "value": 149,
        "label": "America/Lower_Princes",
    },
    {
        "value": 150,
        "label": "America/Maceio",
    },
    {
        "value": 151,
        "label": "America/Managua",
    },
    {
        "value": 152,
        "label": "America/Manaus",
    },
    {
        "value": 153,
        "label": "America/Marigot",
    },
    {
        "value": 154,
        "label": "America/Martinique",
    },
    {
        "value": 155,
        "label": "America/Matamoros",
    },
    {
        "value": 156,
        "label": "America/Mazatlan",
    },
    {
        "value": 157,
        "label": "America/Mendoza",
    },
    {
        "value": 158,
        "label": "America/Menominee",
    },
    {
        "value": 159,
        "label": "America/Merida",
    },
    {
        "value": 160,
        "label": "America/Metlakatla",
    },
    {
        "value": 161,
        "label": "America/Mexico_City",
    },
    {
        "value": 162,
        "label": "America/Miquelon",
    },
    {
        "value": 163,
        "label": "America/Moncton",
    },
    {
        "value": 164,
        "label": "America/Monterrey",
    },
    {
        "value": 165,
        "label": "America/Montevideo",
    },
    {
        "value": 166,
        "label": "America/Montreal",
    },
    {
        "value": 167,
        "label": "America/Montserrat",
    },
    {
        "value": 168,
        "label": "America/Nassau",
    },
    {
        "value": 169,
        "label": "America/New_York",
    },
    {
        "value": 170,
        "label": "America/Nipigon",
    },
    {
        "value": 171,
        "label": "America/Nome",
    },
    {
        "value": 172,
        "label": "America/Noronha",
    },
    {
        "value": 173,
        "label": "America/North_Dakota/Beulah",
    },
    {
        "value": 174,
        "label": "America/North_Dakota/Center",
    },
    {
        "value": 175,
        "label": "America/North_Dakota/New_Salem",
    },
    {
        "value": 176,
        "label": "America/Ojinaga",
    },
    {
        "value": 177,
        "label": "America/Panama",
    },
    {
        "value": 178,
        "label": "America/Pangnirtung",
    },
    {
        "value": 179,
        "label": "America/Paramaribo",
    },
    {
        "value": 180,
        "label": "America/Phoenix",
    },
    {
        "value": 181,
        "label": "America/Port-au-Prince",
    },
    {
        "value": 182,
        "label": "America/Port_of_Spain",
    },
    {
        "value": 183,
        "label": "America/Porto_Acre",
    },
    {
        "value": 184,
        "label": "America/Porto_Velho",
    },
    {
        "value": 185,
        "label": "America/Puerto_Rico",
    },
    {
        "value": 186,
        "label": "America/Punta_Arenas",
    },
    {
        "value": 187,
        "label": "America/Rainy_River",
    },
    {
        "value": 188,
        "label": "America/Rankin_Inlet",
    },
    {
        "value": 189,
        "label": "America/Recife",
    },
    {
        "value": 190,
        "label": "America/Regina",
    },
    {
        "value": 191,
        "label": "America/Resolute",
    },
    {
        "value": 192,
        "label": "America/Rio_Branco",
    },
    {
        "value": 193,
        "label": "America/Rosario",
    },
    {
        "value": 194,
        "label": "America/Santa_Isabel",
    },
    {
        "value": 195,
        "label": "America/Santarem",
    },
    {
        "value": 196,
        "label": "America/Santiago",
    },
    {
        "value": 197,
        "label": "America/Santo_Domingo",
    },
    {
        "value": 198,
        "label": "America/Sao_Paulo",
    },
    {
        "value": 199,
        "label": "America/Scoresbysund",
    },
    {
        "value": 200,
        "label": "America/Shiprock",
    },
    {
        "value": 201,
        "label": "America/Sitka",
    },
    {
        "value": 202,
        "label": "America/St_Barthelemy",
    },
    {
        "value": 203,
        "label": "America/St_Johns",
    },
    {
        "value": 204,
        "label": "America/St_Kitts",
    },
    {
        "value": 205,
        "label": "America/St_Lucia",
    },
    {
        "value": 206,
        "label": "America/St_Thomas",
    },
    {
        "value": 207,
        "label": "America/St_Vincent",
    },
    {
        "value": 208,
        "label": "America/Swift_Current",
    },
    {
        "value": 209,
        "label": "America/Tegucigalpa",
    },
    {
        "value": 210,
        "label": "America/Thule",
    },
    {
        "value": 211,
        "label": "America/Thunder_Bay",
    },
    {
        "value": 212,
        "label": "America/Tijuana",
    },
    {
        "value": 213,
        "label": "America/Toronto",
    },
    {
        "value": 214,
        "label": "America/Tortola",
    },
    {
        "value": 215,
        "label": "America/Vancouver",
    },
    {
        "value": 216,
        "label": "America/Virgin",
    },
    {
        "value": 217,
        "label": "America/Whitehorse",
    },
    {
        "value": 218,
        "label": "America/Winnipeg",
    },
    {
        "value": 219,
        "label": "America/Yakutat",
    },
    {
        "value": 220,
        "label": "America/Yellowknife",
    },
    {
        "value": 221,
        "label": "Antarctica/Casey",
    },
    {
        "value": 222,
        "label": "Antarctica/Davis",
    },
    {
        "value": 223,
        "label": "Antarctica/DumontDUrville",
    },
    {
        "value": 224,
        "label": "Antarctica/Macquarie",
    },
    {
        "value": 225,
        "label": "Antarctica/Mawson",
    },
    {
        "value": 226,
        "label": "Antarctica/McMurdo",
    },
    {
        "value": 227,
        "label": "Antarctica/Palmer",
    },
    {
        "value": 228,
        "label": "Antarctica/Rothera",
    },
    {
        "value": 229,
        "label": "Antarctica/South_Pole",
    },
    {
        "value": 230,
        "label": "Antarctica/Syowa",
    },
    {
        "value": 231,
        "label": "Antarctica/Troll",
    },
    {
        "value": 232,
        "label": "Antarctica/Vostok",
    },
    {
        "value": 233,
        "label": "Arctic/Longyearbyen",
    },
    {
        "value": 234,
        "label": "Asia/Aden",
    },
    {
        "value": 235,
        "label": "Asia/Almaty",
    },
    {
        "value": 236,
        "label": "Asia/Amman",
    },
    {
        "value": 237,
        "label": "Asia/Anadyr",
    },
    {
        "value": 238,
        "label": "Asia/Aqtau",
    },
    {
        "value": 239,
        "label": "Asia/Aqtobe",
    },
    {
        "value": 240,
        "label": "Asia/Ashgabat",
    },
    {
        "value": 241,
        "label": "Asia/Ashkhabad",
    },
    {
        "value": 242,
        "label": "Asia/Atyrau",
    },
    {
        "value": 243,
        "label": "Asia/Baghdad",
    },
    {
        "value": 244,
        "label": "Asia/Bahrain",
    },
    {
        "value": 245,
        "label": "Asia/Baku",
    },
    {
        "value": 246,
        "label": "Asia/Bangkok",
    },
    {
        "value": 247,
        "label": "Asia/Barnaul",
    },
    {
        "value": 248,
        "label": "Asia/Beirut",
    },
    {
        "value": 249,
        "label": "Asia/Bishkek",
    },
    {
        "value": 250,
        "label": "Asia/Brunei",
    },
    {
        "value": 251,
        "label": "Asia/Calcutta",
    },
    {
        "value": 252,
        "label": "Asia/Chita",
    },
    {
        "value": 253,
        "label": "Asia/Choibalsan",
    },
    {
        "value": 254,
        "label": "Asia/Chongqing",
    },
    {
        "value": 255,
        "label": "Asia/Chungking",
    },
    {
        "value": 256,
        "label": "Asia/Colombo",
    },
    {
        "value": 257,
        "label": "Asia/Dacca",
    },
    {
        "value": 258,
        "label": "Asia/Damascus",
    },
    {
        "value": 259,
        "label": "Asia/Dhaka",
    },
    {
        "value": 260,
        "label": "Asia/Dili",
    },
    {
        "value": 261,
        "label": "Asia/Dubai",
    },
    {
        "value": 262,
        "label": "Asia/Dushanbe",
    },
    {
        "value": 263,
        "label": "Asia/Famagusta",
    },
    {
        "value": 264,
        "label": "Asia/Gaza",
    },
    {
        "value": 265,
        "label": "Asia/Harbin",
    },
    {
        "value": 266,
        "label": "Asia/Hebron",
    },
    {
        "value": 267,
        "label": "Asia/Ho_Chi_Minh",
    },
    {
        "value": 268,
        "label": "Asia/Hong_Kong",
    },
    {
        "value": 269,
        "label": "Asia/Hovd",
    },
    {
        "value": 270,
        "label": "Asia/Irkutsk",
    },
    {
        "value": 271,
        "label": "Asia/Istanbul",
    },
    {
        "value": 272,
        "label": "Asia/Jakarta",
    },
    {
        "value": 273,
        "label": "Asia/Jayapura",
    },
    {
        "value": 274,
        "label": "Asia/Jerusalem",
    },
    {
        "value": 275,
        "label": "Asia/Kabul",
    },
    {
        "value": 276,
        "label": "Asia/Kamchatka",
    },
    {
        "value": 277,
        "label": "Asia/Karachi",
    },
    {
        "value": 278,
        "label": "Asia/Kashgar",
    },
    {
        "value": 279,
        "label": "Asia/Kathmandu",
    },
    {
        "value": 280,
        "label": "Asia/Katmandu",
    },
    {
        "value": 281,
        "label": "Asia/Khandyga",
    },
    {
        "value": 282,
        "label": "Asia/Kolkata",
    },
    {
        "value": 283,
        "label": "Asia/Krasnoyarsk",
    },
    {
        "value": 284,
        "label": "Asia/Kuala_Lumpur",
    },
    {
        "value": 285,
        "label": "Asia/Kuching",
    },
    {
        "value": 286,
        "label": "Asia/Kuwait",
    },
    {
        "value": 287,
        "label": "Asia/Macao",
    },
    {
        "value": 288,
        "label": "Asia/Macau",
    },
    {
        "value": 289,
        "label": "Asia/Magadan",
    },
    {
        "value": 290,
        "label": "Asia/Makassar",
    },
    {
        "value": 291,
        "label": "Asia/Manila",
    },
    {
        "value": 292,
        "label": "Asia/Muscat",
    },
    {
        "value": 293,
        "label": "Asia/Nicosia",
    },
    {
        "value": 294,
        "label": "Asia/Novokuznetsk",
    },
    {
        "value": 295,
        "label": "Asia/Novosibirsk",
    },
    {
        "value": 296,
        "label": "Asia/Omsk",
    },
    {
        "value": 297,
        "label": "Asia/Oral",
    },
    {
        "value": 298,
        "label": "Asia/Phnom_Penh",
    },
    {
        "value": 299,
        "label": "Asia/Pontianak",
    },
    {
        "value": 300,
        "label": "Asia/Pyongyang",
    },
    {
        "value": 301,
        "label": "Asia/Qatar",
    },
    {
        "value": 302,
        "label": "Asia/Qostanay",
    },
    {
        "value": 303,
        "label": "Asia/Qyzylorda",
    },
    {
        "value": 304,
        "label": "Asia/Rangoon",
    },
    {
        "value": 305,
        "label": "Asia/Riyadh",
    },
    {
        "value": 306,
        "label": "Asia/Saigon",
    },
    {
        "value": 307,
        "label": "Asia/Sakhalin",
    },
    {
        "value": 308,
        "label": "Asia/Samarkand",
    },
    {
        "value": 309,
        "label": "Asia/Seoul",
    },
    {
        "value": 310,
        "label": "Asia/Shanghai",
    },
    {
        "value": 311,
        "label": "Asia/Singapore",
    },
    {
        "value": 312,
        "label": "Asia/Srednekolymsk",
    },
    {
        "value": 313,
        "label": "Asia/Taipei",
    },
    {
        "value": 314,
        "label": "Asia/Tashkent",
    },
    {
        "value": 315,
        "label": "Asia/Tbilisi",
    },
    {
        "value": 316,
        "label": "Asia/Tehran",
    },
    {
        "value": 317,
        "label": "Asia/Tel_Aviv",
    },
    {
        "value": 318,
        "label": "Asia/Thimbu",
    },
    {
        "value": 319,
        "label": "Asia/Thimphu",
    },
    {
        "value": 320,
        "label": "Asia/Tokyo",
    },
    {
        "value": 321,
        "label": "Asia/Tomsk",
    },
    {
        "value": 322,
        "label": "Asia/Ujung_Pandang",
    },
    {
        "value": 323,
        "label": "Asia/Ulaanbaatar",
    },
    {
        "value": 324,
        "label": "Asia/Ulan_Bator",
    },
    {
        "value": 325,
        "label": "Asia/Urumqi",
    },
    {
        "value": 326,
        "label": "Asia/Ust-Nera",
    },
    {
        "value": 327,
        "label": "Asia/Vientiane",
    },
    {
        "value": 328,
        "label": "Asia/Vladivostok",
    },
    {
        "value": 329,
        "label": "Asia/Yakutsk",
    },
    {
        "value": 330,
        "label": "Asia/Yangon",
    },
    {
        "value": 331,
        "label": "Asia/Yekaterinburg",
    },
    {
        "value": 332,
        "label": "Asia/Yerevan",
    },
    {
        "value": 333,
        "label": "Atlantic/Azores",
    },
    {
        "value": 334,
        "label": "Atlantic/Bermuda",
    },
    {
        "value": 335,
        "label": "Atlantic/Canary",
    },
    {
        "value": 336,
        "label": "Atlantic/Cape_Verde",
    },
    {
        "value": 337,
        "label": "Atlantic/Faeroe",
    },
    {
        "value": 338,
        "label": "Atlantic/Faroe",
    },
    {
        "value": 339,
        "label": "Atlantic/Jan_Mayen",
    },
    {
        "value": 340,
        "label": "Atlantic/Madeira",
    },
    {
        "value": 341,
        "label": "Atlantic/Reykjavik",
    },
    {
        "value": 342,
        "label": "Atlantic/South_Georgia",
    },
    {
        "value": 343,
        "label": "Atlantic/St_Helena",
    },
    {
        "value": 344,
        "label": "Atlantic/Stanley",
    },
    {
        "value": 345,
        "label": "Australia/ACT",
    },
    {
        "value": 346,
        "label": "Australia/Adelaide",
    },
    {
        "value": 347,
        "label": "Australia/Brisbane",
    },
    {
        "value": 348,
        "label": "Australia/Broken_Hill",
    },
    {
        "value": 349,
        "label": "Australia/Canberra",
    },
    {
        "value": 350,
        "label": "Australia/Currie",
    },
    {
        "value": 351,
        "label": "Australia/Darwin",
    },
    {
        "value": 352,
        "label": "Australia/Eucla",
    },
    {
        "value": 353,
        "label": "Australia/Hobart",
    },
    {
        "value": 354,
        "label": "Australia/LHI",
    },
    {
        "value": 355,
        "label": "Australia/Lindeman",
    },
    {
        "value": 356,
        "label": "Australia/Lord_Howe",
    },
    {
        "value": 357,
        "label": "Australia/Melbourne",
    },
    {
        "value": 358,
        "label": "Australia/NSW",
    },
    {
        "value": 359,
        "label": "Australia/North",
    },
    {
        "value": 360,
        "label": "Australia/Perth",
    },
    {
        "value": 361,
        "label": "Australia/Queensland",
    },
    {
        "value": 362,
        "label": "Australia/South",
    },
    {
        "value": 363,
        "label": "Australia/Sydney",
    },
    {
        "value": 364,
        "label": "Australia/Tasmania",
    },
    {
        "value": 365,
        "label": "Australia/Victoria",
    },
    {
        "value": 366,
        "label": "Australia/West",
    },
    {
        "value": 367,
        "label": "Australia/Yancowinna",
    },
    {
        "value": 368,
        "label": "Brazil/Acre",
    },
    {
        "value": 369,
        "label": "Brazil/DeNoronha",
    },
    {
        "value": 370,
        "label": "Brazil/East",
    },
    {
        "value": 371,
        "label": "Brazil/West",
    },
    {
        "value": 372,
        "label": "CET",
    },
    {
        "value": 373,
        "label": "CST6CDT",
    },
    {
        "value": 374,
        "label": "Canada/Atlantic",
    },
    {
        "value": 375,
        "label": "Canada/Central",
    },
    {
        "value": 376,
        "label": "Canada/Eastern",
    },
    {
        "value": 377,
        "label": "Canada/Mountain",
    },
    {
        "value": 378,
        "label": "Canada/Newfoundland",
    },
    {
        "value": 379,
        "label": "Canada/Pacific",
    },
    {
        "value": 380,
        "label": "Canada/Saskatchewan",
    },
    {
        "value": 381,
        "label": "Canada/Yukon",
    },
    {
        "value": 382,
        "label": "Chile/Continental",
    },
    {
        "value": 383,
        "label": "Chile/EasterIsland",
    },
    {
        "value": 384,
        "label": "Cuba",
    },
    {
        "value": 385,
        "label": "EET",
    },
    {
        "value": 386,
        "label": "EST",
    },
    {
        "value": 387,
        "label": "EST5EDT",
    },
    {
        "value": 388,
        "label": "Egypt",
    },
    {
        "value": 389,
        "label": "Eire",
    },
    {
        "value": 390,
        "label": "Etc/GMT",
    },
    {
        "value": 391,
        "label": "Etc/GMT+0",
    },
    {
        "value": 392,
        "label": "Etc/GMT+1",
    },
    {
        "value": 393,
        "label": "Etc/GMT+10",
    },
    {
        "value": 394,
        "label": "Etc/GMT+11",
    },
    {
        "value": 395,
        "label": "Etc/GMT+12",
    },
    {
        "value": 396,
        "label": "Etc/GMT+2",
    },
    {
        "value": 397,
        "label": "Etc/GMT+3",
    },
    {
        "value": 398,
        "label": "Etc/GMT+4",
    },
    {
        "value": 399,
        "label": "Etc/GMT+5",
    },
    {
        "value": 400,
        "label": "Etc/GMT+6",
    },
    {
        "value": 401,
        "label": "Etc/GMT+7",
    },
    {
        "value": 402,
        "label": "Etc/GMT+8",
    },
    {
        "value": 403,
        "label": "Etc/GMT+9",
    },
    {
        "value": 404,
        "label": "Etc/GMT-0",
    },
    {
        "value": 405,
        "label": "Etc/GMT-1",
    },
    {
        "value": 406,
        "label": "Etc/GMT-10",
    },
    {
        "value": 407,
        "label": "Etc/GMT-11",
    },
    {
        "value": 408,
        "label": "Etc/GMT-12",
    },
    {
        "value": 409,
        "label": "Etc/GMT-13",
    },
    {
        "value": 410,
        "label": "Etc/GMT-14",
    },
    {
        "value": 411,
        "label": "Etc/GMT-2",
    },
    {
        "value": 412,
        "label": "Etc/GMT-3",
    },
    {
        "value": 413,
        "label": "Etc/GMT-4",
    },
    {
        "value": 414,
        "label": "Etc/GMT-5",
    },
    {
        "value": 415,
        "label": "Etc/GMT-6",
    },
    {
        "value": 416,
        "label": "Etc/GMT-7",
    },
    {
        "value": 417,
        "label": "Etc/GMT-8",
    },
    {
        "value": 418,
        "label": "Etc/GMT-9",
    },
    {
        "value": 419,
        "label": "Etc/GMT0",
    },
    {
        "value": 420,
        "label": "Etc/Greenwich",
    },
    {
        "value": 421,
        "label": "Etc/UCT",
    },
    {
        "value": 422,
        "label": "Etc/UTC",
    },
    {
        "value": 423,
        "label": "Etc/Universal",
    },
    {
        "value": 424,
        "label": "Etc/Zulu",
    },
    {
        "value": 425,
        "label": "Europe/Amsterdam",
    },
    {
        "value": 426,
        "label": "Europe/Andorra",
    },
    {
        "value": 427,
        "label": "Europe/Astrakhan",
    },
    {
        "value": 428,
        "label": "Europe/Athens",
    },
    {
        "value": 429,
        "label": "Europe/Belfast",
    },
    {
        "value": 430,
        "label": "Europe/Belgrade",
    },
    {
        "value": 431,
        "label": "Europe/Berlin",
    },
    {
        "value": 432,
        "label": "Europe/Bratislava",
    },
    {
        "value": 433,
        "label": "Europe/Brussels",
    },
    {
        "value": 434,
        "label": "Europe/Bucharest",
    },
    {
        "value": 435,
        "label": "Europe/Budapest",
    },
    {
        "value": 436,
        "label": "Europe/Busingen",
    },
    {
        "value": 437,
        "label": "Europe/Chisinau",
    },
    {
        "value": 438,
        "label": "Europe/Copenhagen",
    },
    {
        "value": 439,
        "label": "Europe/Dublin",
    },
    {
        "value": 440,
        "label": "Europe/Gibraltar",
    },
    {
        "value": 441,
        "label": "Europe/Guernsey",
    },
    {
        "value": 442,
        "label": "Europe/Helsinki",
    },
    {
        "value": 443,
        "label": "Europe/Isle_of_Man",
    },
    {
        "value": 444,
        "label": "Europe/Istanbul",
    },
    {
        "value": 445,
        "label": "Europe/Jersey",
    },
    {
        "value": 446,
        "label": "Europe/Kaliningrad",
    },
    {
        "value": 447,
        "label": "Europe/Kiev",
    },
    {
        "value": 448,
        "label": "Europe/Kirov",
    },
    {
        "value": 449,
        "label": "Europe/Lisbon",
    },
    {
        "value": 450,
        "label": "Europe/Ljubljana",
    },
    {
        "value": 451,
        "label": "Europe/London",
    },
    {
        "value": 452,
        "label": "Europe/Luxembourg",
    },
    {
        "value": 453,
        "label": "Europe/Madrid",
    },
    {
        "value": 454,
        "label": "Europe/Malta",
    },
    {
        "value": 455,
        "label": "Europe/Mariehamn",
    },
    {
        "value": 456,
        "label": "Europe/Minsk",
    },
    {
        "value": 457,
        "label": "Europe/Monaco",
    },
    {
        "value": 458,
        "label": "Europe/Moscow",
    },
    {
        "value": 459,
        "label": "Europe/Nicosia",
    },
    {
        "value": 460,
        "label": "Europe/Oslo",
    },
    {
        "value": 461,
        "label": "Europe/Paris",
    },
    {
        "value": 462,
        "label": "Europe/Podgorica",
    },
    {
        "value": 463,
        "label": "Europe/Prague",
    },
    {
        "value": 464,
        "label": "Europe/Riga",
    },
    {
        "value": 465,
        "label": "Europe/Rome",
    },
    {
        "value": 466,
        "label": "Europe/Samara",
    },
    {
        "value": 467,
        "label": "Europe/San_Marino",
    },
    {
        "value": 468,
        "label": "Europe/Sarajevo",
    },
    {
        "value": 469,
        "label": "Europe/Saratov",
    },
    {
        "value": 470,
        "label": "Europe/Simferopol",
    },
    {
        "value": 471,
        "label": "Europe/Skopje",
    },
    {
        "value": 472,
        "label": "Europe/Sofia",
    },
    {
        "value": 473,
        "label": "Europe/Stockholm",
    },
    {
        "value": 474,
        "label": "Europe/Tallinn",
    },
    {
        "value": 475,
        "label": "Europe/Tirane",
    },
    {
        "value": 476,
        "label": "Europe/Tiraspol",
    },
    {
        "value": 477,
        "label": "Europe/Ulyanovsk",
    },
    {
        "value": 478,
        "label": "Europe/Uzhgorod",
    },
    {
        "value": 479,
        "label": "Europe/Vaduz",
    },
    {
        "value": 480,
        "label": "Europe/Vatican",
    },
    {
        "value": 481,
        "label": "Europe/Vienna",
    },
    {
        "value": 482,
        "label": "Europe/Vilnius",
    },
    {
        "value": 483,
        "label": "Europe/Volgograd",
    },
    {
        "value": 484,
        "label": "Europe/Warsaw",
    },
    {
        "value": 485,
        "label": "Europe/Zagreb",
    },
    {
        "value": 486,
        "label": "Europe/Zaporozhye",
    },
    {
        "value": 487,
        "label": "Europe/Zurich",
    },
    {
        "value": 488,
        "label": "GB",
    },
    {
        "value": 489,
        "label": "GB-Eire",
    },
    {
        "value": 490,
        "label": "GMT",
    },
    {
        "value": 491,
        "label": "GMT+0",
    },
    {
        "value": 492,
        "label": "GMT-0",
    },
    {
        "value": 493,
        "label": "GMT0",
    },
    {
        "value": 494,
        "label": "Greenwich",
    },
    {
        "value": 495,
        "label": "HST",
    },
    {
        "value": 496,
        "label": "Hongkong",
    },
    {
        "value": 497,
        "label": "Iceland",
    },
    {
        "value": 498,
        "label": "Indian/Antananarivo",
    },
    {
        "value": 499,
        "label": "Indian/Chagos",
    },
    {
        "value": 500,
        "label": "Indian/Christmas",
    },
    {
        "value": 501,
        "label": "Indian/Cocos",
    },
    {
        "value": 502,
        "label": "Indian/Comoro",
    },
    {
        "value": 503,
        "label": "Indian/Kerguelen",
    },
    {
        "value": 504,
        "label": "Indian/Mahe",
    },
    {
        "value": 505,
        "label": "Indian/Maldives",
    },
    {
        "value": 506,
        "label": "Indian/Mauritius",
    },
    {
        "value": 507,
        "label": "Indian/Mayotte",
    },
    {
        "value": 508,
        "label": "Indian/Reunion",
    },
    {
        "value": 509,
        "label": "Iran",
    },
    {
        "value": 510,
        "label": "Israel",
    },
    {
        "value": 511,
        "label": "Jamaica",
    },
    {
        "value": 512,
        "label": "Japan",
    },
    {
        "value": 513,
        "label": "Kwajalein",
    },
    {
        "value": 514,
        "label": "Libya",
    },
    {
        "value": 515,
        "label": "MET",
    },
    {
        "value": 516,
        "label": "MST",
    },
    {
        "value": 517,
        "label": "MST7MDT",
    },
    {
        "value": 518,
        "label": "Mexico/BajaNorte",
    },
    {
        "value": 519,
        "label": "Mexico/BajaSur",
    },
    {
        "value": 520,
        "label": "Mexico/General",
    },
    {
        "value": 521,
        "label": "NZ",
    },
    {
        "value": 522,
        "label": "NZ-CHAT",
    },
    {
        "value": 523,
        "label": "Navajo",
    },
    {
        "value": 524,
        "label": "PRC",
    },
    {
        "value": 525,
        "label": "PST8PDT",
    },
    {
        "value": 526,
        "label": "Pacific/Apia",
    },
    {
        "value": 527,
        "label": "Pacific/Auckland",
    },
    {
        "value": 528,
        "label": "Pacific/Bougainville",
    },
    {
        "value": 529,
        "label": "Pacific/Chatham",
    },
    {
        "value": 530,
        "label": "Pacific/Chuuk",
    },
    {
        "value": 531,
        "label": "Pacific/Easter",
    },
    {
        "value": 532,
        "label": "Pacific/Efate",
    },
    {
        "value": 533,
        "label": "Pacific/Enderbury",
    },
    {
        "value": 534,
        "label": "Pacific/Fakaofo",
    },
    {
        "value": 535,
        "label": "Pacific/Fiji",
    },
    {
        "value": 536,
        "label": "Pacific/Funafuti",
    },
    {
        "value": 537,
        "label": "Pacific/Galapagos",
    },
    {
        "value": 538,
        "label": "Pacific/Gambier",
    },
    {
        "value": 539,
        "label": "Pacific/Guadalcanal",
    },
    {
        "value": 540,
        "label": "Pacific/Guam",
    },
    {
        "value": 541,
        "label": "Pacific/Honolulu",
    },
    {
        "value": 542,
        "label": "Pacific/Johnston",
    },
    {
        "value": 543,
        "label": "Pacific/Kiritimati",
    },
    {
        "value": 544,
        "label": "Pacific/Kosrae",
    },
    {
        "value": 545,
        "label": "Pacific/Kwajalein",
    },
    {
        "value": 546,
        "label": "Pacific/Majuro",
    },
    {
        "value": 547,
        "label": "Pacific/Marquesas",
    },
    {
        "value": 548,
        "label": "Pacific/Midway",
    },
    {
        "value": 549,
        "label": "Pacific/Nauru",
    },
    {
        "value": 550,
        "label": "Pacific/Niue",
    },
    {
        "value": 551,
        "label": "Pacific/Norfolk",
    },
    {
        "value": 552,
        "label": "Pacific/Noumea",
    },
    {
        "value": 553,
        "label": "Pacific/Pago_Pago",
    },
    {
        "value": 554,
        "label": "Pacific/Palau",
    },
    {
        "value": 555,
        "label": "Pacific/Pitcairn",
    },
    {
        "value": 556,
        "label": "Pacific/Pohnpei",
    },
    {
        "value": 557,
        "label": "Pacific/Ponape",
    },
    {
        "value": 558,
        "label": "Pacific/Port_Moresby",
    },
    {
        "value": 559,
        "label": "Pacific/Rarotonga",
    },
    {
        "value": 560,
        "label": "Pacific/Saipan",
    },
    {
        "value": 561,
        "label": "Pacific/Samoa",
    },
    {
        "value": 562,
        "label": "Pacific/Tahiti",
    },
    {
        "value": 563,
        "label": "Pacific/Tarawa",
    },
    {
        "value": 564,
        "label": "Pacific/Tongatapu",
    },
    {
        "value": 565,
        "label": "Pacific/Truk",
    },
    {
        "value": 566,
        "label": "Pacific/Wake",
    },
    {
        "value": 567,
        "label": "Pacific/Wallis",
    },
    {
        "value": 568,
        "label": "Pacific/Yap",
    },
    {
        "value": 569,
        "label": "Poland",
    },
    {
        "value": 570,
        "label": "Portugal",
    },
    {
        "value": 571,
        "label": "ROC",
    },
    {
        "value": 572,
        "label": "ROK",
    },
    {
        "value": 573,
        "label": "Singapore",
    },
    {
        "value": 574,
        "label": "Turkey",
    },
    {
        "value": 575,
        "label": "UCT",
    },
    {
        "value": 576,
        "label": "US/Alaska",
    },
    {
        "value": 577,
        "label": "US/Aleutian",
    },
    {
        "value": 578,
        "label": "US/Arizona",
    },
    {
        "value": 579,
        "label": "US/Central",
    },
    {
        "value": 580,
        "label": "US/East-Indiana",
    },
    {
        "value": 581,
        "label": "US/Eastern",
    },
    {
        "value": 582,
        "label": "US/Hawaii",
    },
    {
        "value": 583,
        "label": "US/Indiana-Starke",
    },
    {
        "value": 584,
        "label": "US/Michigan",
    },
    {
        "value": 585,
        "label": "US/Mountain",
    },
    {
        "value": 586,
        "label": "US/Pacific",
    },
    {
        "value": 587,
        "label": "US/Pacific-New",
    },
    {
        "value": 588,
        "label": "US/Samoa",
    },
    {
        "value": UTC_TIMEZONE_ID,
        "label": "UTC",
    },
    {
        "value": 590,
        "label": "Universal",
    },
    {
        "value": 591,
        "label": "W-SU",
    },
    {
        "value": 592,
        "label": "WET",
    },
    {
        "value": 593,
        "label": "Zulu",
    },
];
// console.log(moment.tz.zone('Europe/Prague'));
// console.log(-moment.tz.zone('Europe/Prague').utcOffset(new Date()));
